var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paper-clip",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.139,
    height: 18.207,
    viewBox: "0 0 19.139 18.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M17.517,13.025a5.4,5.4,0,0,0-7.548,0l-8.8,8.8A4.121,4.121,0,0,0,7,27.649l7.964-7.964a2.651,2.651,0,1,0-3.75-3.75L3.6,23.553a.693.693,0,0,0,.979.979l7.618-7.618A1.267,1.267,0,0,1,13.986,18.7L6.021,26.669A2.736,2.736,0,0,1,2.153,22.8l8.8-8.8a4.012,4.012,0,1,1,5.676,5.673l-8.8,8.8a.693.693,0,1,0,.977.977l8.8-8.8A5.4,5.4,0,0,0,17.517,13.025Z",
    transform: "translate(0 -11.486)",
    fill: "#8c9297"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment_icon.1660532960cd198eec5066f8741c3e85.svg";
export { ForwardRef as ReactComponent };